<yat-card [isMinified]="isMinified" [iconName]="'edit-field-duo'" [showIcon]="showIcon" (cardSelect)="onCardSelect()">
  <div class="flex flex-col">
    <div class="flex items-center gap-2">
      <yat-icon name="persons" *ngIf="areNamesToBeDisplayed && persons.length > 1"></yat-icon>
      <yat-icon id="526de23a-b59c-4886-bd55-0e765fae5979" name="person" *ngIf="areNamesToBeDisplayed && persons.length === 1 && showIcon"></yat-icon>
      <div #container class="overflow-hidden relative w-[calc(100%_-_48px)]">
        <p
          *ngIf="areNamesToBeDisplayed; else noNamesToDisplay"
          #namesText
          class="whitespace-nowrap font-medium"
          [class.scrolling-text]="isTextOverflowing"
          [style.--scroll-distance]="scrollDistance">
          {{ persons | selectedPersonCard }}
        </p>
        <ng-template #noNamesToDisplay>
          <p class="text-n-40">
            {{
              ((personalizationAdditionStatus$ | async) === 'NOT_SET'
                ? 'commercialCheckout.personalization.selectedPersonCard.enterPersonalInformation'
                : (maxNumberOfPersons$ | async) === 1
                ? 'commercialCheckout.personalization.selectedPersonCard.addPassenger'
                : 'commercialCheckout.personalization.selectedPersonCard.addPassengers'
              ) | transloco
            }}
          </p>
        </ng-template>
      </div>
    </div>
    <p class="text-n-40 text-sm" *ngIf="persons.length > 1">
      {{ 'commercialCheckout.personalization.selectedPersonCard.people' | transloco: { numberOfPersons: persons.length } }}
    </p>
  </div>
  <ng-container *ngIf="personalizationAdditionStatus$ | async as status">
    <p *ngIf="status === 'INCOMPLETE'" class="incomplete-personalization text-[12px] mt-1">
      {{ 'commercialCheckout.personalization.selectedPersonCard.dataIncomplete' | transloco }}
    </p>
  </ng-container>
</yat-card>
